import { VehicleType } from "./daily-report.model";

export interface BodyHourlyReport {
  sucursal: string;
  fechaInicio: string;
  fechaFin: string;
}

export interface ResponseHourlyReport {
  Mes:             string;
  Día:             string;
  Hora:          number;
  Fecha:           string;
  Total:           number | string;
  Acceso:          string;
  "Tipo Vehículo": VehicleType;
}
